import React, { useEffect, useState} from "react";
import FormControl from '@mui/material/FormControl';
import { Form } from "react-bootstrap";
import Autocomplete from '@mui/material/Autocomplete';
import { TextField, Tooltip, IconButton } from "@mui/material"
import Box from '@mui/material/Box';
import { HelpCenter } from "@mui/icons-material";
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const SensorForm = props => {
    return(
        <Form>
            {
                ['add', 'edit'].includes(props.modalState) &&
                <>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Sensor name"
                        variant="outlined"
                        name="sensor-name"
                        value={props.createForm.name.value}
                        onChange={e => props.updateCreateFormValue('name', e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.createForm.name.error !== ''}
                        helperText={props.createForm.name.error}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title="Name to be given to the sensor in Stewwi" style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{width:'100%', marginBottom:'2vh'}}>
                    <Autocomplete
                        disablePortal
                        id="centrica-modal-unit-type"
                        options={props.unitTypes}
                        value={props.createForm.unitType.value}
                        fullWidth
                        getOptionLabel={option => option.text}
                        onChange={(_, option) => props.updateCreateFormValue('unitType', option)}
                        renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                <span>{option.text}</span>
                            </Box>
                        )}
                        renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps}} label="Unit type" />}
                    />
                    {props.createForm.unitType.error !== '' && <FormHelperText error>
                        {props.createForm.unitType.error}
                    </FormHelperText>}
                </div>

                <br/>

                <FormControl fullWidth>
                    <InputLabel id="mcat-simple-select-label">Measurement category</InputLabel>
                    <Select
                        value={props.measurementCategories.value}
                        disabled={props.measurementCategories.options.length === 1}
                        label='Measurement category'
                        onChange={e => {
                            props.setMeasurementCategories(prev => ({...prev, value: e.target.value}));
                            props.setQuantities(prev => ({...prev, value: ''}));
                            props.setUnits(prev => ({...prev, value: ''}));
                        }}
                        MenuProps={{ disablePortal: true }}
                    >
                        {
                            props.measurementCategories.options.map((mCat, _) => (
                                <MenuItem value={mCat.id}>{mCat.sub_category_name ? `${mCat.sub_category_name}` : `${mCat.category_name}`}</MenuItem>
                            ))
                        }
                    </Select>
                    {props.measurementCategories.error !== '' && <FormHelperText error>
                            {props.measurementCategories.error}
                            </FormHelperText>}
                </FormControl>

                <br/>
                <br/>

                <FormControl fullWidth>
                    <InputLabel id="mcat-simple-select-label">Measured quantity</InputLabel>
                    <Select
                        value={props.quantities.value}
                        disabled={props.quantities.options.length === 1}
                        label='Measured quantity'
                        onChange={e => {
                            props.setQuantities(prev => ({...prev, value: e.target.value}));
                            props.setUnits(prev => ({...prev, value: ''}));
                        }}
                        MenuProps={{ disablePortal: true }}
                    >
                        {
                            props.quantities.options
                                .filter(qty => !qty.measurement_category_ids || qty.measurement_category_ids.includes(Number(props.measurementCategories.value)))
                                .map((qty, _) => (
                                <MenuItem value={qty.id}>{qty.quantity}</MenuItem>
                            ))
                        }
                    </Select>
                    {props.quantities.error !== '' && <FormHelperText error>
                        {props.quantities.error}
                        </FormHelperText>}
                </FormControl>

                <br/>
                <br/>

                <FormControl fullWidth>
                    <InputLabel id="mcat-simple-select-label">Units</InputLabel>
                    <Select
                        value={props.units.value}
                        disabled={props.units.options.length === 1}
                        label='Units'
                        onChange={e => {
                            props.setUnits(prev => ({...prev, value: e.target.value}));
                        }}
                        MenuProps={{ disablePortal: true }}
                    >
                        {
                            props.units.options
                                .filter(unit => unit.quantity_id == props.quantities.value)
                                .filter(unit => !unit.measurement_category_ids || unit.measurement_category_ids.includes(Number(props.measurementCategories.value)))
                                .map((unit, _) => (
                                <MenuItem value={unit.id}>{unit.unit_symbol}</MenuItem>
                            ))
                        }
                    </Select>
                    {props.units.error !== '' && <FormHelperText error>
                        {props.units.error}
                        </FormHelperText>}
                </FormControl>
                </>
            }
        </Form>
    )
}

export default SensorForm;
